export enum UpdatePaymentTokenReason {
  REDEMPTION = 'redemption',
  PREPAID = 'prepaid',
}
